import Swiper from 'swiper/bundle';

class ContentHubBildErklaertextSlider {
  constructor(options = {}) {
    this.element = options.element;
    this.swiperContainer = this.element.querySelector('.swiper-container');

    this.suffixId = this.element.dataset.suffixId;
    this.nextEl = `#swiper-button-next-${this.suffixId}`;
    this.prevEl = `#swiper-button-prev-${this.suffixId}`;
  }

  init() {
    this.expertSlider = new Swiper(this.swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        formatFractionCurrent(number) {
          return (`0${number}`).slice(-2);
        },
        formatFractionTotal(number) {
          return (`0${number}`).slice(-2);
        },
      },
      navigation: {
        nextEl: this.nextEl,
        prevEl: this.prevEl,
      },
      loop: true,
      direction: 'horizontal',
    });
  }

}

export default ContentHubBildErklaertextSlider;
